var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfV2 = function SvgPdfV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pdf_v2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4H5v9h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z",
    fill: "var(--color-primary-800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.538 16.668c0 .285-.065.546-.196.784-.13.233-.331.422-.602.567-.27.145-.607.217-1.008.217H6.99V20H5.793v-4.914h1.939c.392 0 .723.068.994.203.27.135.474.322.609.56.135.238.203.511.203.819Zm-1.897.616c.229 0 .399-.054.51-.161.113-.107.169-.259.169-.455s-.056-.348-.168-.455c-.112-.107-.282-.161-.511-.161H6.99v1.232h.65Zm4.361-2.198c.518 0 .97.103 1.358.308.387.205.686.495.896.868.215.369.322.796.322 1.281 0 .48-.107.908-.322 1.281-.21.373-.51.663-.903.868-.387.205-.838.308-1.35.308H10.16v-4.914h1.841Zm-.077 3.878c.453 0 .805-.124 1.057-.371.252-.247.378-.597.378-1.05 0-.453-.126-.805-.378-1.057-.252-.252-.604-.378-1.057-.378h-.567v2.856h.567Zm6.521-3.878v.959h-2.002v1.036h1.498v.931h-1.498V20h-1.197v-4.914h3.199Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdf_v2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPdfV2;